import { Injectable, inject } from '@angular/core';
import { UserAuth } from '@ls-commons/models';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { UserActions, UserActionsType } from '../actions';
import * as selectors from '../selectors';

@Injectable()
export class UsersFacade {
  #store = inject(Store);
  loading = this.#store.selectSignal(
    selectors.selectUsersActionType([UserActionsType.C_GET_USERS])
  );
  loadingUser = this.#store.selectSignal(
    selectors.selectUsersActionType([UserActionsType.C_GET_USER])
  );
  savingUser = this.#store.selectSignal(
    selectors.selectUsersActionType([
      UserActionsType.C_UPDATE_USER,
      UserActionsType.C_ADD_USER,
    ])
  );

  private observableError$ = this.#store
    .select(selectors.selectUsersError)
    .pipe(filter(({ error }) => error !== null));

  deleteError$ = this.observableError$.pipe(
    filter(({ type }) => type === UserActionsType.C_DELETE_USER_FAILED)
  );
  updateError$ = this.observableError$.pipe(
    filter(({ type }) => type === UserActionsType.C_UPDATE_USER_FAILED)
  );
  addError$ = this.observableError$.pipe(
    filter(({ type }) => type === UserActionsType.C_ADD_USER_FAILED)
  );
  userError$ = this.observableError$.pipe(
    filter(({ type }) => type === UserActionsType.C_GET_USER_FAILED)
  );
  usersError$ = this.observableError$.pipe(
    filter(({ type }) => type === UserActionsType.C_GET_USERS_FAILED)
  );

  deletedUser$ = this.#store.select(selectors.selectDeletedUser);
  modifiedUser = this.#store.select(selectors.selectModifiedUser);
  selecUsers$ = this.#store.select(selectors.selectUsers);
  selectedUser$ = this.#store.select(selectors.selectUser);

  getUsers() {
    this.#store.dispatch(UserActions.getUsers());
  }
  deleteUser(user: UserAuth) {
    this.#store.dispatch(UserActions.deleteUser({ user }));
  }
  getUser(id: number) {
    this.#store.dispatch(UserActions.getUser({ id }));
  }
  addUser(user: UserAuth) {
    this.#store.dispatch(UserActions.addUser({ user }));
  }
  updateUser(user: UserAuth) {
    this.#store.dispatch(UserActions.updateUser({ user }));
  }
  clearError() {
    this.#store.dispatch(UserActions.clearError());
  }
}
